import styled from "styled-components";

export const Container = styled.div`
	font-size: clamp(1px, 4dvw, 18px);
	margin: 1.25em auto 2.5em;
	padding: 2.125em 1.2em 1.4em;
	border-radius: 1.5em;
	background: rgba(255, 255, 255, 0.95);
	box-shadow: 0 0.75em 1.5em rgba(0, 0, 0, 0.25);
	text-align: center;
	width: 19.3125em;
	height: 19.8125em;
	box-sizing: border-box;

	@media (orientation: landscape) {
		font-size: clamp(1px, 1.6dvw, 18px);
	}
`;

export const Title = styled.div`
	color: #113b62;
	text-align: center;
	font-family: Baloo;
	font-size: 2.6875em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.85em;
`;

export const Subtitle = styled.div`
	color: #333;
	text-align: center;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.15;
`;

export const Image = styled.img`
	position: relative;
	top: 0.1em;
	width: 10.69em;
	height: 7.56em;
	object-fit: contain;
`;

export const ButtonWrapper = styled.div`
	width: 100%;
`;
